import React, { useState } from "react";
import { m as motion } from "../../shared/components/Motion";
import PreviewModal from "../PreviewModal";
import { useAdmin } from "../../features/admin/AdminProvider";
import { cld } from "../../shared/utils";

// Resolves either a Cloudinary public ID or a legacy full URL.
const resolveImg = (val, width) => {
  if (!val) return "";
  if (val.startsWith("http")) return val;
  return cld(val, width);
};

const WorkItems = ({ item, onEdit, onDelete }) => {
  const { adminMode } = useAdmin();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [imageError, setImageError] = useState(false);

  // Prefer new Cloudinary public ID; fall back to legacy cached URL.
  const imgSrc = resolveImg(item.imageId || item.image, 710);

  const handleEdit = (e) => {
    e.stopPropagation();
    onEdit && onEdit(item);
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    onDelete && onDelete(item.id);
  };

  const cardVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1, delayChildren: 0.05 },
    },
  };

  return (
    <motion.div
      className="work__card"
      key={item.id}
      variants={cardVariants}
      initial="hidden"
      animate="visible"
      style={{ position: "relative" }}
    >
      {adminMode && (
        <div
          style={{
            position: "absolute",
            top: "0.5rem",
            right: "0.5rem",
            zIndex: 10,
            display: "flex",
            gap: "0.5rem",
          }}
        >
          <motion.button
            title="Edit project"
            whileHover={{ scale: 1.15 }}
            whileTap={{ scale: 0.9 }}
            onClick={handleEdit}
            style={{
              width: "36px",
              height: "36px",
              borderRadius: "50%",
              background: "var(--title-color)",
              color: "var(--container-color)",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "1rem",
              boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
            }}
          >
            <i className="bx bx-edit-alt"></i>
          </motion.button>
          <motion.button
            title="Delete project"
            onClick={handleDelete}
            whileHover={{ scale: 1.15 }}
            whileTap={{ scale: 0.9 }}
            style={{
              width: "36px",
              height: "36px",
              borderRadius: "50%",
              background: "var(--title-color)",
              color: "var(--container-color)",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              fontSize: "1rem",
              boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
            }}
          >
            <i className="bx bx-trash"></i>
          </motion.button>
        </div>
      )}
      <div
        className="work__img-container work__img"
        style={{
          background: imageError
            ? "color-mix(in srgb, var(--title-color) 15%, transparent)"
            : "",
        }}
        onClick={() => setIsModalOpen(true)}
      >
        {imageError && (
          <div className="image-error__others">
            <i className="uil uil-image-slash"></i>
          </div>
        )}
        <img
          src={imgSrc}
          alt={item.title}
          width="355"
          height="220"
          loading="lazy"
          decoding="async"
          className="work__img"
          onError={() => setImageError(true)}
          style={{ display: imageError ? "none" : "block" }}
        />
      </div>
      <h3 className="work__title">{item.title}</h3>

      <PreviewModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        image={imgSrc}
        title={item.title}
        projectDescription={item.description}
        skills={item.skills}
        keyLearnings={item.keyLearnings}
        codelink={item.codelink}
        demolink={item.demolink}
      />

      <div
        className="work__button-container"
        onClick={() => setIsModalOpen(true)}
      >
        <span className="work__button">
          View more
          <i className="bx bx-right-arrow-alt work__button-icon"></i>
        </span>
      </div>
    </motion.div>
  );
};

export default WorkItems;
